import React, { useEffect, useState } from 'react';
import {
  DeparrtmentSelectorContainer,
  SelectDepartmentContainer,
  TemplateSelectionContainert,
} from './SelfAssessmentSelectDepartment.styled';
import { Body4, Headline3 } from '../../../common/typography';
import { AppHeader } from '../../../common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { HeaderContainer } from '../../../../components/SelfAssessments/styled.SelfAssessment';
import { getAvailableTemplate } from '../../../../components/SelfAssessmentAssignDepartment/apiCaller';
import { getItem, removeItem, setItem } from '../../../../utils/localStorage';
import { DepartmentSelector } from '../../../selfAssessment/components/DepartmentSelector';
import { DropdownSingle } from '../../../common/sharedComponents/DropdownSingle';
import {
  createSelfAssessmentv2,
  getDepartments,
} from '../../../selfAssessment/requests';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../../../common/sharedComponents/buttons/ButtonLarge';
import { SelfAssessmentSelectDepartmentSkeleton } from './Skeleton';
import { useLocation, useNavigate } from 'react-router-dom';
import { sentryReport } from '../../../../helpers/sentry';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../../helpers/showMessage';
import UnsavedFormDataModal from '../../../../components/commons/UnsavedFormDataModal';
import moment from 'moment';
import {
  IDepartmentSelector,
  IDepartmentSelectorOptions,
  IDropdownTemplateOption,
  ISelfAssesmentDepartmentDetails,
  ISelfAssessmentCreation,
  ISelfAssessmentPayload,
} from '../../../@types/selfAssessment';
import { getSelfAssessment } from '../../../../components/SelfAssessments/apiCaller';
import { getTemplateData } from '../../../../requests/login';
import { filterTemplateData } from '../../../../helpers/filterData';
import { Modal } from '../../../common/sharedComponents/Modal';
import {
  ModalContent,
  ModalHeader,
} from '../../../common/sharedStyledComponents/Modal.styled';

export function SelfAssessmentSelectDepartment () {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location: any = useLocation();
  const subDepartmentNameFromState =
    location.state && location.state.subDepartmentName;
  const templateFromState = location.state && location.state.templateId;

  const { user } = getItem('user');
  setItem('isFormData', true);
  const brandId = JSON.parse(getItem('selectedBrand'));
  const hotelId = JSON.parse(getItem('selectedHotel'));
  const selfAssessmentInitialState: ISelfAssessmentCreation = {
    brandId,
    hotelId,
    subject: '',
    notes: '',
    dueDate: '',
    assignee: {
      id: 0,
      text: '',
    },
    departments: [
      {
        subDepartments: [
          {
            subDepartmentId: 0,
            subDepartmentName: '',
            isAssignMore: false,
          },
        ],
        departmentName: '',
        departmentId: 0,
      },
    ],
    templateId: 0,
  };
  const selfAssessmentFromLocalStorage: ISelfAssessmentCreation[] = getItem(
    'selfAssessments'
  );
  const selfAssessment: ISelfAssessmentCreation[] =
    selfAssessmentFromLocalStorage && selfAssessmentFromLocalStorage.length > 0
      ? selfAssessmentFromLocalStorage
      : [selfAssessmentInitialState];

  const allSelectedSubDepartments = selfAssessment.flatMap(
    (selfAssessment) =>
      selfAssessment.departments &&
      selfAssessment.departments.flatMap((department) =>
        department.subDepartments.flatMap(
          (subDepartment) => subDepartment.subDepartmentId
        )
      )
  );

  const currentSelfAssessment =
    JSON.parse(getItem('currentSelfAssessmentIndex')) || 0;

  if (currentSelfAssessment > 0) {
    selfAssessment.push(selfAssessmentInitialState);
  }

  selfAssessment[currentSelfAssessment].subject =
    selfAssessment[0].subject || '';
  selfAssessment[currentSelfAssessment].dueDate =
    selfAssessment[0].dueDate || '';

  selfAssessment[currentSelfAssessment].templateId =
    selfAssessment[0].templateId || 0;

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [templates, setTemplates] = useState<IDropdownTemplateOption[]>([]);
  const [departments, setDepartments] = useState<
    ISelfAssesmentDepartmentDetails[]
  >([]);
  const [selectedTemplate, setSelectedTemplate] = useState<number>(0);
  const [departmentOptions, setDepartmentOptions] = useState<
    IDepartmentSelector[]
  >([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState<
    (number | string)[]
  >([]);
  const [currentSelfAssessmentIndex] = useState<number>(currentSelfAssessment);
  const [showUnsavedDataModal, setShowUnsavedDataModal] = useState<boolean>(
    false
  );
  const [
    isQuickSelfAssessmentLoading,
    setQuickSelfAssessmentLoading,
  ] = useState<boolean>(false);
  const [
    isQuickSelfAssessmentModalOpen,
    setIsQuickSelfAssessmentModalOpen,
  ] = useState<boolean>(false);

  useEffect(() => {
    Promise.all([getAvailableTemplate(), getDepartments()])
      .then((response) => {
        const [activeTemplates, departmentsForTemplates] = response;
        const templateDropdownOptions: IDropdownTemplateOption[] = activeTemplates.filter(aT => aT.id).map(
          (template) => {
            setSelectedTemplate(template.id);
            return {
              label: template.name,
              value: template.id.toString(),
              templateId: template.id,
            };
          }
        );

        const filteredInitialStateDepartments: ISelfAssesmentDepartmentDetails[] = departmentsForTemplates.departments.filter(
          (department) => {
            return activeTemplates[0].id === department.templateId;
          }
        );

        const parsedDepartmentOptions: IDepartmentSelector[] = parseDepartmentOptions(
          filteredInitialStateDepartments
        );
        const currentlySelectedTemplate = selfAssessment[0].templateId !== 0 && selfAssessment[0].templateId;
        const selectedTemplate =
          (templateFromState && templateFromState) || currentlySelectedTemplate || activeTemplates[0].id;
        setDepartmentOptions(parsedDepartmentOptions!);
        setTemplates(templateDropdownOptions);
        setDepartments(departmentsForTemplates.departments);
        setSelectedTemplate(selectedTemplate);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleSelectTemplate = (option: IDropdownTemplateOption) => {
    setSelectedTemplate(option.templateId);
    const filteredByTemplateDepartments = departments.filter((department) => {
      return option.templateId === department.templateId;
    });
    const parsedDepartmentOptions: IDepartmentSelector[] = parseDepartmentOptions(
      filteredByTemplateDepartments
    );
    setDepartmentOptions(parsedDepartmentOptions);
    setSelectedSubCategories([]);
  };

  const validateALlOptionsSelected = () => {
    return departmentOptions
      .flatMap((department) => department.options)
      .every((option) => option.checked);
  };

  const parseDepartmentOptions = (
    departments: ISelfAssesmentDepartmentDetails[]
  ) => {
    return departments.map((department, index) => {
      const isAllSubDepartmentsSelected = department.subDepartments.every(
        (subDepartment) =>
          allSelectedSubDepartments.includes(subDepartment.subDepartmentId)
      );

      const isAssignMore = selfAssessment
        .flatMap((sa) => sa.departments || [])
        .flatMap(
          (dep) =>
            (dep.departmentName.toLowerCase() ===
              department.departmentName.toLowerCase() &&
              dep.subDepartments) ||
            []
        )
        .every((subDepartment) => subDepartment.isAssignMore);

      const isAllDisabled = isAllSubDepartmentsSelected && isAssignMore;
      const allCheckboxField: IDepartmentSelectorOptions = {
        label: 'all',
        optionCallback: () => handleChecked('all', index),
        disabled: isAllDisabled,
        checked: department.subDepartments.every((subDepartment) =>
          allSelectedSubDepartments.includes(subDepartment.subDepartmentId)
        ),
        id: 'all',
      };

      const subDepartments: IDepartmentSelectorOptions[] = department.subDepartments.map(
        (subDepartment) => {
          const subDepartmentFromState =
            subDepartment.subDepartmentName === subDepartmentNameFromState;

          const shouldIncludeSubDepartment = selfAssessment.some(
            (selfAssessment) =>
              selfAssessment.departments!.some((department) =>
                department.subDepartments.some(
                  (sub) => sub.subDepartmentId === subDepartment.subDepartmentId
                )
              )
          );

          if (subDepartmentFromState || shouldIncludeSubDepartment) {
            setSelectedSubCategories((previousSubCategories) => {
              if (
                previousSubCategories.some(
                  (id) => id === subDepartment.subDepartmentId
                )
              ) {
                return previousSubCategories.filter(
                  () => 'all' !== subDepartment.subDepartmentId
                );
              }
              return [...previousSubCategories, subDepartment.subDepartmentId];
            });
          }

          const isAssingMore = selfAssessment.some((selfAssessment) =>
            selfAssessment.departments!.some((department) =>
              department.subDepartments.some(
                (sub) =>
                  sub.subDepartmentId === subDepartment.subDepartmentId &&
                  sub.isAssignMore
              )
            )
          );
          const isDisabled =
            allSelectedSubDepartments.includes(subDepartment.subDepartmentId) &&
            isAssingMore;
          const isChecked =
            subDepartmentFromState ||
            allSelectedSubDepartments.includes(subDepartment.subDepartmentId);
          return {
            label: subDepartment.subDepartmentName.toLowerCase(),
            optionCallback: () =>
              handleChecked(subDepartment.subDepartmentId, index),
            disabled: isDisabled,
            checked: isChecked,
            id: subDepartment.subDepartmentId,
          };
        }
      );
      subDepartments.unshift(allCheckboxField);
      return {
        title: department.departmentName,
        options: subDepartments,
      };
    });
  };

  const selectAllHelper = (
    option: IDepartmentSelectorOptions,
    department: IDepartmentSelector,
    isSelectAll: boolean
  ) => {
    setSelectedSubCategories((previousSubCategories) => {
      const departmentSubDepartmentIds = department.options
        .filter((opt) => opt.id !== 'all')
        .map((opt) => opt.id);

      if (isSelectAll) {
        return [
          ...new Set([...previousSubCategories, ...departmentSubDepartmentIds]),
        ];
      } else {
        return previousSubCategories.filter(
          (id) => !departmentSubDepartmentIds.includes(id)
        );
      }
    });

    return {
      ...option,
      checked: !department.options[0].checked,
    };
  };

  const handleChecked = (
    selectedOptionId: string | number,
    departmentIndex: number
  ) => {
    setDepartmentOptions((previousOptions) => {
      return previousOptions.map((department, index) => {
        if (index === departmentIndex) {
          const updatedOptions = department.options.map((option) => {
            if (selectedOptionId === 'all' && option.id === selectedOptionId) {
              return {
                ...option,
                checked: !option.checked,
              };
            }
            if (selectedOptionId === 'all' && option.id !== selectedOptionId) {
              const isSelectAll = !department.options[0].checked;
              return selectAllHelper(option, department, isSelectAll);
            }

            if (selectedOptionId !== 'all' && option.id === selectedOptionId) {
              setSelectedSubCategories((previousSubCategories) => {
                if (previousSubCategories.some((id) => id === option.id)) {
                  return previousSubCategories.filter((id) => id !== option.id);
                }
                return [...previousSubCategories, option.id];
              });

              return {
                ...option,
                checked: !option.checked,
              };
            }
            return option;
          });

          const allChecked = updatedOptions
            .filter((option) => option.id !== 'all')
            .every((option) => option.checked);

          const finalOptions = updatedOptions.map((option) => {
            if (option.id === 'all') {
              return {
                ...option,
                checked: allChecked,
              };
            }
            return option;
          });
          return {
            ...department,
            options: finalOptions,
          };
        }
        return department;
      });
    });
  };

  const parseSelfAssessment = () => {
    const parsedSelfAssessment: ISelfAssesmentDepartmentDetails[] = departmentOptions
      .filter((department) =>
        department.options.some((option) => option.checked && !option.disabled)
      )
      .map((department) => ({
        departmentName: department.title,
        subDepartments: department.options
          .filter(
            (option) =>
              option.checked && option.label !== 'all' && !option.disabled
          )
          .map((option) => ({
            subDepartmentName: option.label,
            subDepartmentId: option.id,
          })),
      }));
    return parsedSelfAssessment;
  };

  const handleAssignDepartments = () => {
    selfAssessment[
      currentSelfAssessmentIndex
    ].departments = parseSelfAssessment();
    selfAssessment[currentSelfAssessmentIndex].templateId = selectedTemplate;
    const isAllOptionsChecked = JSON.stringify(validateALlOptionsSelected());
    setItem('isAllOptionsChecked', isAllOptionsChecked);
    setItem('currentSelfAssessmentIndex', currentSelfAssessmentIndex);
    setItem('selfAssessments', selfAssessment);
    navigate('/selfAssessment/assign');
  };

  const createQuickSelfAssessment = () => {
    const date = new Date();
    const selfAssessmentPayload: ISelfAssessmentPayload[] = [
      {
        brandId,
        hotelId,
        subject: `${t(
          'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.QUICK_SELF_ASSESSMENT'
        )} - on ${moment(date).format('Do MMMM YYYY, hh:mm a')}`,
        notes: t(
          'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.QUICK_SELF_ASSESSMENT'
        ),
        dueDate: new Date(),
        subDepartments: selectedSubCategories,
        templateId: selectedTemplate,
        assigneeId: user.id,
      },
    ];
    setQuickSelfAssessmentLoading(true);
    createSelfAssessmentv2(selfAssessmentPayload)
      .then((response) => {
        // TODO update this logic to when new API's for conduct self assessment are created
        const { selfAssessmentId } = response;
        getSelfAssessment(selfAssessmentId)
          .then(async (assessmentData) => {
            const userData = getItem('user');
            const saTemplateId = assessmentData.template.id;
            const templateData: any = await getTemplateData(
              saTemplateId,
              userData
            );
            const cloneTemplateData: any = { ...templateData };
            let categoriesData: any = [];
            if (templateData) {
              const duplicateCategories = assessmentData.duplicateCategories.map(
                (duplicatedCategory) => duplicatedCategory.templateCategoryId
              );
              let categories = templateData.category.filter(
                (category) => category.categoryType === 'category'
              );
              const subCategories = templateData.category.filter(
                (category) =>
                  category.categoryType === 'subCategory' &&
                  duplicateCategories.includes(category.id)
              );
              const superCategories = templateData.category.filter(
                (category) => category.categoryType === 'superCategory'
              );
              categories = categories
                .map((category, i) => {
                  const childs = subCategories.filter((subCategory) =>
                    category.categories.includes(subCategory.uuid)
                  );
                  const parent = superCategories.filter((superCategory) =>
                    superCategory.categories.includes(category.uuid)
                  );
                  if (childs.length > 0) {
                    return {
                      ...category,
                      subCategories: childs,
                      superCategories: parent,
                    };
                  } else {
                    return null;
                  }
                })
                .filter(Boolean);
              cloneTemplateData.category = [
                ...categories,
                ...subCategories,
                ...superCategories,
              ];
              categoriesData = categories;
            }
            setItem('isFormData', false);
            setQuickSelfAssessmentLoading(false);
            navigate('/editSelfAssessment', {
              state: {
                assess: assessmentData,
                assessmentId: selfAssessmentId,
                // parentId:   const userData = getItem('user');,
                categoryId: categoriesData[0].uuid,
                template: filterTemplateData(cloneTemplateData),
              },
            });
            showSuccessMessage('Self Assessment Created Successfully');
          })
          .catch((error) => {
            showErrorMessage(
              t(
                'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.ERROR_MESSAGES.UNABLE_TO_CREATE_QUICK_SELF_ASSESSMENT'
              )
            );
          });
      })
      .catch((error) => {
        sentryReport(
          error.response ? error.response.data : '',
          error.message,
          error.code,
          {
            summaryError: t(
              'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.ERROR_MESSAGES.UNABLE_TO_CREATE_QUICK_SELF_ASSESSMENT'
            ),
            path: '/selfAssessment/selectDepartment',
          }
        );
        showErrorMessage(
          t(
            'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.ERROR_MESSAGES.UNABLE_TO_CREATE_QUICK_SELF_ASSESSMENT'
          )
        );
      })
      .finally(() => setQuickSelfAssessmentLoading(false));
  };

  const handleFinalize = () => {
    const filteredSelfAssessment = selfAssessment.filter(sa => sa.assignee.text !== '');
    setItem('selfAssessments', filteredSelfAssessment);
    navigate('/selfAssessment/preview');
  };

  return (
    <>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.SELF_ASSESSMENT.TITLE')}
          navigateTo="/myactions"
          hasBackButton={true}
        />
      </HeaderContainer>
      {isLoading && <SelfAssessmentSelectDepartmentSkeleton />}
      {!isLoading && (
        <SelectDepartmentContainer>
          <TemplateSelectionContainert>
            <Headline3>
              {templates.length > 1
                ? t(
                    'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.CHOOSE_TEMPLATE'
                  )
                : t('COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.TEMPLATE')}
            </Headline3>
            {templates.length > 1 ? (
              <DropdownSingle
                defaultOption={
                  templates.find(
                    (template) => template.templateId === selectedTemplate
                  ) || templates[0]
                }
                options={templates}
                isClearable={false}
                callback={handleSelectTemplate}
                disabled={selfAssessment.length > 1}
              />
            ) : (
              <Body4>{templates[0].label}</Body4>
            )}
          </TemplateSelectionContainert>
          <DeparrtmentSelectorContainer>
            {departmentOptions &&
              departmentOptions.map((department, index) => (
                <DepartmentSelector
                  key={department.title + index}
                  title={department.title}
                  options={department.options}
                />
              ))}
          </DeparrtmentSelectorContainer>
          <ButtonBlockColumn>
            <ButtonLarge
              disabled={selectedSubCategories.length === 0}
              title={t(
                'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.ASSIGN_DEPARTMENTS'
              )}
              onClick={handleAssignDepartments}
              loading={isQuickSelfAssessmentLoading}
            />
            {currentSelfAssessmentIndex === 0 && (
              <ButtonLarge
                disabled={selectedSubCategories.length === 0}
                backgroundColor="verdigris"
                textColor="oxfordBlue"
                title={t(
                  'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.QUICK_SELF_ASSESSMENT'
                )}
                onClick={() => {
                  setIsQuickSelfAssessmentModalOpen(true);
                }}
                loading={isQuickSelfAssessmentLoading}
              />
            )}
            {currentSelfAssessmentIndex > 0 && (
              <ButtonLarge
                backgroundColor="verdigris"
                textColor="oxfordBlue"
                title={t(
                  'COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.FINALIZE'
                )}
                onClick={handleFinalize}
              />
            )}
            <ButtonLarge
              outlined={true}
              inverted={true}
              title={t('COMMON.SELF_ASSESSMENT.PAGES.SELECT_DEPARTMENTS.BACK')}
              onClick={() => {
                setShowUnsavedDataModal(true);
              }}
              disabled={isQuickSelfAssessmentLoading}
            />
          </ButtonBlockColumn>
        </SelectDepartmentContainer>
      )}
      {showUnsavedDataModal && (
        <UnsavedFormDataModal
          showUnsavedDataModal={showUnsavedDataModal}
          setShowUnsavedDataModal={setShowUnsavedDataModal}
          onContinue={() => {
            removeItem('selfAssessments');
            removeItem('currentSelfAssessmentIndex');
            navigate('/myActions');
          }}
        />
      )}
      {isQuickSelfAssessmentModalOpen && (
        <Modal
          isOpen={isQuickSelfAssessmentModalOpen}
          handleModalClose={() => {
            setIsQuickSelfAssessmentModalOpen(false);
          }}
        >
          <ModalHeader>
            <Headline3>
              {t(
                'COMMON.SELF_ASSESSMENT.MESSAGES.QUICK_SELF_ASSESSMENT_CONFIRMATION'
              )}
            </Headline3>
          </ModalHeader>
          <ModalContent>
            <Body4>
              {t(
                'COMMON.SELF_ASSESSMENT.MESSAGES.QUICK_SELF_ASSESSMENT_CONFIRMATION_NOTE'
              )}
            </Body4>
          </ModalContent>
          <ButtonBlockColumn>
            <ButtonLarge
              title={t('COMMON.OUTSIDE.BUTTONS.CANCEL')}
              onClick={() => {
                setIsQuickSelfAssessmentModalOpen(false);
              }}
              outlined={true}
              inverted={true}
            />
            <ButtonLarge
              title={t(
                'COMMON.SELF_ASSESSMENT.BUTTON.CREATE_SELF_QUICK_ASSESSMENT'
              )}
              onClick={() => {
                setItem('isFormData', false);
                createQuickSelfAssessment();
                setShowUnsavedDataModal(false);
              }}
              loading={isQuickSelfAssessmentLoading}
            />
          </ButtonBlockColumn>
        </Modal>
      )}
    </>
  );
}
